import { ImageLoaderProps } from "next/image";

export default function sanityLoader({ src, width, quality }: ImageLoaderProps) {
  const url = new URL(src);
  url.searchParams.set("w", width?.toString() ?? "300");
  url.searchParams.set("q", quality?.toString() || "95");
  return url.toString();
}
